////
/// ============================================================================
/// COMPONENT / Floating Button
/// ============================================================================
///
/// @group components
////

import "../vendors/cookie-manager";

export default () => {

    window.$ = jQuery;

    var open = false;
    var container = $('.js-floatingBtn');
    var toggle = $('.js-floatingBtnToggle');

    if (!container.length || !toggle.length) {
        return;
    }

    function openNews() {
        container.addClass('is-visible');
        toggle.addClass('is-open');
        open = true;
    }

    function closeNews() {
        window.cookieManager.create('floatingBtn', true, 2);
        container.removeClass('is-visible');
        toggle.removeClass('is-open');
        open = false;
    }

    toggle.click(function () {
        if (open) {
            closeNews();
        } else {
            openNews();
        }
    });

    setTimeout(function () {
        if (!window.cookieManager.read('floatingBtn')) {
            openNews();
        }
    }, 10000000);

};
